import { Checkbox, CheckboxProps } from '@chakra-ui/react';

export function DrawerCheckbox(props: CheckboxProps) {
    return <Checkbox {...props} />;
}
